import { useMemo } from 'react'
import { useQuery } from 'react-query'
import { FacilityEditModalForm } from './FacilitieEditModalForm'
import { isNotEmpty, QUERIES } from '../../../../../_dashboard/helpers'
import { useListView } from '../core/ListViewProvider'
import { getOneByIdbylang } from '../../../../services/common_requests'
import { Facility, initialFacility } from '../core/_models'

const FACILITY_MODAL_CREATE_TEMPLATE: Facility = {
  ...initialFacility,
  _id: undefined,
  translations: (initialFacility.translations || [{ language: 'en', title: '' }]).map((t) => ({
    ...t,
  })),
}

const FacilityEditModalFormWrapper = () => {
  const { itemIdForUpdate, setItemIdForUpdate } = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)

  const facilityLoadingShell = useMemo((): Facility => {
    return {
      ...FACILITY_MODAL_CREATE_TEMPLATE,
      _id: itemIdForUpdate,
      translations: FACILITY_MODAL_CREATE_TEMPLATE.translations.map((t) => ({ ...t })),
    }
  }, [itemIdForUpdate])

  const {
    isLoading,
    data: Facility,
    error,
  } = useQuery(
    `${QUERIES.FACILITIES_LIST}-Facility-${itemIdForUpdate}`,
    () => {
      return getOneByIdbylang(`/facilities/${itemIdForUpdate}?language=all`)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: () => {
        setItemIdForUpdate(undefined)
      },
    },
  )

  if (!itemIdForUpdate) {
    return (
      <FacilityEditModalForm isFacilityLoading={isLoading} Facility={FACILITY_MODAL_CREATE_TEMPLATE} />
    )
  }

  if (enabledQuery && (isLoading || (!error && !Facility))) {
    return <FacilityEditModalForm isFacilityLoading={true} Facility={facilityLoadingShell} />
  }

  if (!isLoading && !error && Facility) {
    return <FacilityEditModalForm isFacilityLoading={false} Facility={Facility} />
  }

  return <FacilityEditModalForm isFacilityLoading={false} Facility={facilityLoadingShell} />
}

export { FacilityEditModalFormWrapper }
